export default class SimplifiedEventsBlock {
    constructor() {
        
    }
}

new SimplifiedEventsBlock();


// WEBPACK FOOTER //
// ../views/modules/simplified-events-block/assets/js/simplified-events-block.js